"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
function CopyToClipboard(content, onMessageSent) {
    if (content == null)
        return;
    const textField = document.createElement('textarea');
    textField.innerText = content;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    if (onMessageSent) {
        onMessageSent(`已複製 ${content}`);
    }
}
function TextCopyButton(props) {
    let style;
    if (props.isSmall) {
        style = { width: '15px' };
    }
    else {
        style = {};
    }
    return (react_1.default.createElement(FileCopy_1.default, { style: style, onClick: (e) => {
            CopyToClipboard(props.text, props.onMessageSent);
            e.stopPropagation();
        } }));
}
exports.TextCopyButton = TextCopyButton;
